import loadable from '@loadable/component'

export const HeroRatings = loadable(() => import('./HeroRatings'))
export const HeroRatingsItem = loadable(() => import('./HeroRatingsItem'))
export { default as heroRatingsMocks } from './__mocks__/HeroRatings.mock'
export type { HeroRatingsProps } from './HeroRatings'
export type {
  HeroRatingsItemProps,
  HeroRatingsItemRenderLinkProps
} from './HeroRatingsItem'
